import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { User } from '../_models';
import { RestService } from './rest.service';
import { environment } from 'environments/environment';
import { from } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
const API_URL = environment.apiurl;
@Injectable({ providedIn: 'root' })
export class UserService {
  constructor(private http: HttpClient, private restService: RestService) { }

  private getArgHeaders(): any {
    let login_access_token = JSON.parse(localStorage.getItem('currentUser'));
    const httpOptions = {
      headers: new HttpHeaders({
        //'Content-Type': 'application/json, application/x-www-form-urlencoded, multipart/form-data',
        'X-Auth-Token': login_access_token.token ? login_access_token.token : '',
      })
    };
    return httpOptions;
  }

  getUserAgentID(param: any) {
    return this.restService.post(param).pipe(map((res: any) => res));
  }
}